// removed by extract-text-webpack-plugin
module.exports = {"column":"header__column-ylg9q","subRow":"header__subRow-xmgXY","id":"header__id-38ZcP","orderBlock":"header__orderBlock-1kLvD","orderDate":"header__orderDate-P0I2Q","priceBlock":"header__priceBlock-37P40"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/header/header.css
// module id = 761
// module chunks = 0